import { ApiService } from "./api.service";
export default class TypeService extends ApiService {
  namespace = "calendar-type";
  icon = "Calendar";
  name = "Adding a Calendar Event";
  favicon = "Calendar";
  window = 290;
  Width = 850;
  action = "action";
  constructor() {
    super("calendars");
  }
}
